import { RequestResponse } from 'interfaces';
import { GetDriverShiftsParams, Shift } from 'ui/pages/DriverShifts/interfaces';
import { request } from 'util/request';

async function getShifts(params?: GetDriverShiftsParams) {
  return request('driver/shifts', params, 'GET');
}

export { getShifts }
